export default "__VITE_ASSET__CtLw$jJV__"